var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#eaa827;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Share-Google",
    transform: "translate(280.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-264.2-339.9c-4.4,0-7.9-3.5-7.9-7.9c0-4.4,3.5-7.9,7.9-7.9c4.4,0,7.9,3.5,7.9,7.9     C-256.3-343.5-259.8-339.9-264.2-339.9L-264.2-339.9z M-264.2-352.8c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9     c2.7,0,4.9-2.2,4.9-4.9C-259.3-350.5-261.5-352.8-264.2-352.8L-264.2-352.8z",
    id: "Fill-61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-232.1-356c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9S-227.8-356-232.1-356     L-232.1-356z M-232.1-368.8c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S-229.4-368.8-232.1-368.8L-232.1-368.8z",
    id: "Fill-62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-232.1-323.9c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9     S-227.8-323.9-232.1-323.9L-232.1-323.9z M-232.1-336.7c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9     S-229.4-336.7-232.1-336.7L-232.1-336.7z",
    id: "Fill-63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-64",
    points: "-238.6,-333.2 -259.2,-343.5 -257.8,-346.4 -237.1,-336.1 -238.6,-333.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-65",
    points: "-257.8,-349.3 -259.2,-352.1 -238.6,-362.4 -237.1,-359.6 -257.8,-349.3    "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.7845f565bb50c2b1b87f38ca21a50367.svg";
export { ForwardRef as ReactComponent };